<template>
    <div v-if="visible" class="ai-notice">
        <span class="ai-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M9 1.5L10.6 6.4L15.5 8L10.6 9.6L9 14.5L7.4 9.6L2.5 8L7.4 6.4L9 1.5Z" fill="currentColor" />
                <path
                    d="M14.75 12.25L15.4 14.1L17.25 14.75L15.4 15.4L14.75 17.25L14.1 15.4L12.25 14.75L14.1 14.1L14.75 12.25Z"
                    fill="currentColor"
                />
            </svg>
        </span>
        <span class="text">{{ text }}</span>
        <span class="dismiss" @click="dismiss">{{ $t("ai_offer.notice_dismiss") }}</span>
    </div>
</template>

<script>
export default {
    name: "AiOfferNotice",
    props: {
        offerUuid: { type: String, default: "" },
        createdByAi: { type: [Number, String], default: 0 },
        estimatedCount: { type: Number, default: 0 },
        totalCount: { type: Number, default: 0 },
    },
    data() {
        return {
            dismissed: false,
        };
    },
    computed: {
        visible() {
            return Number(this.createdByAi) === 1 && !this.dismissed && this.totalCount > 0;
        },
        text() {
            if (this.estimatedCount === 0) {
                return this.$t("ai_offer.notice_all_from_list");
            }
            return this.$t("ai_offer.notice_text")
                .replace("{estimated}", this.estimatedCount)
                .replace("{total}", this.totalCount);
        },
    },
    methods: {
        dismiss() {
            this.dismissed = true;
            if (!this.offerUuid) return;
            axios.post(`/api/ai/offer/${this.offerUuid}/dismiss-notice`).catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.ai-notice {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: #faf0de;
    border-left: 3px solid #b0761f;
    border-radius: 0 6px 6px 0;
    padding: 12px 16px;
    margin-bottom: 16px;
    .ai-icon {
        flex: none;
        width: 30px;
        height: 30px;
        border-radius: 8px;
        background: #fff;
        color: #b0761f;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .text {
        flex: 1;
        font-size: 14px;
        color: #6b4a12;
        line-height: 1.45;
    }
    .dismiss {
        cursor: pointer;
        font-weight: 600;
        font-size: 13.5px;
        color: #b0761f;
        white-space: nowrap;
    }
}
</style>
